import $ from 'jquery';

class LiveSearchMachines {
    constructor () {
        this.searchField = $('#search-input-machines');
        this.machinesPageContent = $('#machines-page-content');
        this.endSearchButton = $('#end-search-button-machines');
        this.searchResultsPageContent = $('#searchResultsPageContentMachines');
        this.frequentlyReadSection = $('#frequently-read-section');
        this.moreResultsButton = $('#more-results-button');
        this.events();
        this.typingTimer;
    }

    events(){
        this.searchField.on("keyup", this.typingLogic.bind(this));
        this.endSearchButton.on('click', this.hideSearchResults.bind(this));
    }

    getResults(){
        this.machinesPageContent.addClass('display-none');
        this.searchResultsPageContent.removeClass('display-none');
        this.frequentlyReadSection.removeClass('display-none');
        $.getJSON(akademiaData.root_url + '/wp-json/wp/v2/product?search=' + this.searchField.val(), (posts) => {
            this.searchResultsPageContent.html(`
            ${posts.length ? `
            <section class='search-results-section'>
                <p class='lighterFont'>Wyniki wyszukiwania: ${posts.length} wyników związanych ze słowem ${this.searchField.val()}</p>
                ${posts.map((post)=> `
                    <a href='${post.link}'>
                        <div class='search-result-card'>
                            <img src='${post.fimg_url}'/>
                            <div class='search-result-card-content'>
                                <h4 class='lighterFont'>${post.title.rendered}</h4>
                                <p class='lighterFont'>${post.content.rendered.slice(0, 200)}...</p>
                            </div>
                        </div>
                    </a>
                `)}
            </section>
            ` : `<p class="lighterFont not-found-info">Brak wyników dla ${this.searchField.val()}.</p>`}
        `)
        })

    }

    typingLogic(){
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.getResults.bind(this), 300)
    }

    hideSearchResults(){
        this.searchResultsPageContent.addClass('display-none');
        this.machinesPageContent.removeClass('display-none');
        this.frequentlyReadSection.addClass('display-none');
        this.searchField.val('')
    }

    showMoreResults(){
        console.log('widzę');
    }


}

export default LiveSearchMachines;